"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AnalyticsService = void 0;
var _uiActions = require("../store/ui/uiActions");
var _questionnaireActions = require("../store/questionnaire/questionnaireActions");
class AnalyticsService {
  constructor(config) {
    this.TAGGING_ID_PREFIX = 'GUIDING_SELLING_WIDGET';
    this.IS_TAGGING_ENABLED = config.enableTealiumTagging !== undefined ? config.enableTealiumTagging : false;
  }
  startJourney() {
    console.log('Journey started');
  }
  _composeTaggingViewEvent(_ref) {
    let {
      pageName,
      eventLabel,
      stepIndex
    } = _ref;
    return {
      taggingId: `${this.TAGGING_ID_PREFIX}_${stepIndex}`,
      taggingType: 'view',
      page_name: this._composeTaggingPageName(pageName),
      event_category: 'tools',
      event_label: eventLabel || `step${stepIndex}`
    };
  }
  _composeTaggingActionEvent(_ref2) {
    let {
      pageName,
      eventLabel,
      stepIndex
    } = _ref2;
    return {
      ...this._composeTaggingViewEvent({
        pageName,
        eventLabel,
        stepIndex
      }),
      taggingType: 'link',
      event_category: 'users',
      event_name: 'ui_interaction',
      event_action: 'click'
    };
  }
  _composeTaggingActionLinkName(_ref3) {
    let {
      prefix,
      action
    } = _ref3;
    return `${prefix}:${action}`;
  }
  _composeTaggingPageName(suffix) {
    return `${this.TAGGING_ID_PREFIX}:${suffix}`;
  }

  /**
   * Compose Tealium tagging events payload based on app lifecycle
   * use "_composeTaggingViewEvent", "_composeTaggingActionEvent" and "_composeTaggingActionLinkName" to overwrite and compose events types for children classes
   * @param {Object} context event payload data
   * @param {String} context.pageName page name composed for the current action (e.g PAGE_NAME:solutions tool:result:TAB_NAME)
   * @param {String} context.eventLabel The event label
   * @param {String} context.stepIndex current step (question) index (-1 for last one)
   */
  composeTaggingEvents(_ref4) {
    let {
      pageName,
      eventLabel,
      stepIndex
    } = _ref4;
    const eventViewTag = this._composeTaggingViewEvent({
      pageName,
      eventLabel,
      stepIndex
    });
    const eventActionTag = this._composeTaggingActionEvent({
      pageName,
      eventLabel,
      stepIndex
    });
    return {
      onToolStart: {
        ...eventViewTag,
        event_name: 'tool_start'
      },
      onToolView: {
        ...eventViewTag,
        event_name: 'tool_view'
      },
      onToolNext: {
        ...eventActionTag,
        link_name: this._composeTaggingActionLinkName({
          prefix: pageName,
          action: 'Next'
        })
      },
      onToolBack: {
        ...eventActionTag,
        link_name: this._composeTaggingActionLinkName({
          prefix: pageName,
          action: 'Back'
        })
      },
      onToolRestart: {
        ...eventActionTag,
        link_name: this._composeTaggingActionLinkName({
          prefix: pageName,
          action: 'Restart'
        })
      },
      onToolEnd: {
        ...eventViewTag,
        event_name: 'tool_end'
      },
      onToolResult: {
        ...eventViewTag,
        event_label: 'result',
        event_name: 'tool_success'
      },
      onToolResultTabSwitch: {
        ...eventViewTag,
        event_label: 'result',
        event_name: 'tool_success'
      },
      onToolShare: {
        ...eventActionTag,
        link_name: this._composeTaggingActionLinkName({
          prefix: pageName,
          action: 'Share'
        })
      },
      onToolCheckout: {
        ...eventActionTag,
        link_name: this._composeTaggingActionLinkName({
          prefix: pageName,
          action: 'Checkout'
        })
      }
    };
  }
  endJourney(_ref5) {
    let {
      handsetProductName,
      planProductName,
      upsoldProductNames,
      broadbandProductName
    } = _ref5;
    console.log(`Journey ended, selected handset product name ${handsetProductName}, plan product name ${planProductName}, upsold product names ${upsoldProductNames}, broadband product name ${broadbandProductName}`);
  }
  getEventsName() {
    return {
      [_uiActions.OPEN_GUIDED_SELLING_MODAL]: {
        eventName: 'onToolStart',
        stepIndex: 0,
        eventLabel: 'start'
      },
      [_questionnaireActions.VIEW_QUESTION]: {
        eventName: 'onToolView'
      },
      [_questionnaireActions.GOTO_NEXT_QUESTION]: {
        eventName: 'onToolNext'
      },
      [_questionnaireActions.GOTO_PREVIOUS_QUESTION]: {
        eventName: 'onToolBack'
      },
      [_questionnaireActions.RESET_QUESTIONNAIRE]: {
        eventName: 'onToolRestart'
      },
      [_questionnaireActions.END_QUESTIONNAIRE]: {
        eventName: 'onToolEnd'
      },
      [_questionnaireActions.ADD_SELECTION]: {
        eventName: 'onToolAnswer'
      },
      [_questionnaireActions.REPLACE_SELECTION]: {
        eventName: 'onToolAnswer'
      },
      [_questionnaireActions.REMOVE_SELECTION]: {
        eventName: 'onToolAnswer'
      }
    };
  }
  getQuestionnaireEventData(currentViewQuestionIndex, pageTitle) {
    return {
      pageName: 'questionnaire',
      eventLabel: pageTitle,
      stepIndex: currentViewQuestionIndex + 1
    };
  }
}
exports.AnalyticsService = AnalyticsService;